import { useAuthStore } from "@/shared/store/useAuthStore";
import { Button, Divider, Popover, Typography } from "antd";
import ArrowDown from "../../icons/arrow-down";
import { useTranslation } from "react-i18next";
import LogoutIcon from "@/shared/icons/logout";
import { logoutHandler } from "@/features/auth/api/auth-handlers";
import { useState } from "react";
import Avatar from "../../../assets/avatar.jpg";
import UserIcon from "@/shared/icons/user";

function ProfilePopover() {
  const { user } = useAuthStore();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Popover
      className="cursor-pointer"
      classNames={{ body: "p-2 pt-2" }}
      placement="bottomRight"
      arrow={false}
      open={open}
      onOpenChange={(visible) => setOpen(visible)}
      content={
        <div className="">
          <Button
            danger
            className="flex w-full justify-normal p-0"
            type="text"
            onClick={logoutHandler}
          >
            <div className="flex items-center gap-3 rounded-lg px-3 py-2 font-medium">
              <LogoutIcon className="text-lg" />
              Чикиш
            </div>
          </Button>
        </div>
      }
      trigger="click"
    >
      <div className="flex h-[36px] items-center gap-3 rounded-[10px] border px-[10px] py-[6px]">
        <div className="flex size-[24px] items-center border p-3 justify-center overflow-hidden rounded-full">
          {/* <img src={Avatar} alt="" /> */}
          <UserIcon />
          {/* <ImageFallback
            src={user?.avatar || Avatar}
            alt="Profile"
            className="h-full w-[24px] object-cover"
            FallbackNode={() => (
              <UserAvatarIcon className="text-secondary text-[24px]" />
            )}
          /> */}
        </div>
        <Typography.Text className="text-[#0E0E0E]">
          Фойдаланувчи
        </Typography.Text>
        <div
          className={`transition-all duration-200 ease-in ${open ? "rotate-180" : ""}`}
        >
          <ArrowDown className="mb-3 text-xs text-[#0E0E0E]" />
        </div>
      </div>
    </Popover>
  );
}

export default ProfilePopover;
